import React from 'react';
import classnames from 'classnames';

import { useImageResize } from '../../../hooks/useImageResize';
import { ImageAndTextComponentFragment } from '../../../../graphql.schema';
import { ContentBlock } from '../../ContentBlock/ContentBlock';
import Image from '../../Image';
// import * as styles from './image-and-text.module.scss';
type ImageAndTextComponentFragmentProps = ImageAndTextComponentFragment & { hasRTL?: boolean };

export const StrapiImageAndTextComponent: React.FC<ImageAndTextComponentFragmentProps> = (props) => {
  const isV2 = process.env.GATSBY_IS_V2 === 'true';
  let styles = require('./image-and-text.module.scss');
  if (isV2) {
    styles = require('./image-and-text-v2.module.scss');
  }

  const { imageWrapper, imageStyle } = useImageResize(props?.mandatory_image ?? { url: '' });
  return (
    <div className={classnames(styles.root, { [styles.alternate]: props.shadedBackground })}>
      <div className="container">
        <div
          ref={imageWrapper}
          className={classnames(styles.wrapper, { [styles.reverse]: props.imagePosition === 'left' })}
        >
          <div className={classnames(styles.contentBlock, props.hasRTL ? styles.rtl : '')}>
            <ContentBlock
              title={props.title}
              titleClass={classnames('is-2', styles.title)}
              contentClass={styles.content}
              content={props.intro ?? undefined}
              links={props.links ?? undefined}
              button={props.button ?? undefined}
            />
          </div>
          <div className={styles.image}>
            <Image image={props.mandatory_image} style={imageStyle} loading="lazy" />
          </div>
        </div>
      </div>
    </div>
  );
};
